// React
import React, { useEffect, useState, useContext } from "react";
// React
// CSS
import styles from "./UserLessons.module.css";

// CSS
// Models
import { I_UserLesson } from "../../Models/interfaces";
// Models
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Utils
import UserLessonCard from "./UserLessonCard/UserLessonCard";
// Utils
// Services
// Services
// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import { getLessons_Service } from "../../Services/Common/getLessons_Service";
// Skeleton

const lessonColors: string[] = [
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
];

const UserLessons = () => {
  const [lessons, setLessons] = useState<I_UserLesson[]>([]);
  const [isPending, setIsPending] = useState<boolean>(true);
  const userToken = useContext(UserTokenContext);

  useEffect(() => {
    if (userToken === "init" || "") return;
    getLessons_Service(userToken)
      .then(({ data: { data } }) => {
        setIsPending(false);
        setLessons(data);
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
  }, [userToken]);

  return (
    <div
      className={`${
        styles.userLessons
      } flex flex-row flex-wrap items-center justify-between pt-4 ${
        isPending ? styles.pendingSkeleton : ""
      } `}
      style={{ paddingBottom: "6vh", direction: "rtl" }}
    >
      {isPending ? (
        <>
          <SkeletonTheme
            baseColor="rgba(126, 58, 229 , 0.1)"
            highlightColor="rgba(126, 0, 229, 0.6)"
          >
            <p>
              <Skeleton count={9} width={"28vw"} height={"150px"} />
            </p>
          </SkeletonTheme>
        </>
      ) : (
        <>
          {lessons.map((item, index) => (
            <UserLessonCard
              imgUrl={item.url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
              name={item.title}
              key={item.id}
              lessonId={item.id}
              lessonData={item}
              filter={lessonColors[index]}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default UserLessons;
